import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LendioDirectoryDialogComponent } from 'app/messages/messages-wrapper/email-smart/lendio-directory-dialog/lendio-directory-dialog.component';
import { Contact } from 'app/models/dto/contact.model';
import { EmailDirectoryListItem } from 'app/models/dto/directory-list-item.model';


@Component({
  selector: 'app-recipient-menu',
  templateUrl: './recipient-menu.component.html',
  styleUrls: ['./recipient-menu.component.scss'],
  standalone: false
})
export class RecipientMenuComponent implements OnInit {

  @Input() borrowerId: number;
  @Input() lendioEmailDirectory: EmailDirectoryListItem[];
  @Input() joinedContacts: Contact[];
  @Input() recipientType: string;
  @Output() addRecipient = new EventEmitter<Contact>();
  @Output() addBCCRecipient = new EventEmitter<Contact>();
  @Output() addLendioRecipient = new EventEmitter<EmailDirectoryListItem>();
  @Output() addLendioBCCRecipient = new EventEmitter<EmailDirectoryListItem>();
  @Output() launchAddNewContactModal = new EventEmitter<boolean>();

  removable = true;
  primary='primary';

  constructor(
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  handleAddRecipient(contact: Contact) {
    this.recipientType === 'to' ? this.addRecipient.emit(contact) : this.addBCCRecipient.emit(contact);
  }

  handleLaunchAddNewContactModal(): void {
    this.launchAddNewContactModal.emit();
  }

  launchLendioDirectory(): void {
    const dialogRef = this.dialog.open(LendioDirectoryDialogComponent, {
      width: '29rem',
      maxHeight: '200vh',
      data: this.lendioEmailDirectory,
      panelClass: 'contact-dialog-container'
    });

    dialogRef.afterClosed().subscribe(lendion => {
      if (!lendion) { return ; }
      this.recipientType === 'to' ? this.addLendioRecipient.emit(lendion) : this.addLendioBCCRecipient.emit(lendion);
    });
  }

}
